module.exports = __webpack_public_path__ + "img/mapway4.43350a8c.jpg";